import { type CurrencyType } from 'src/types/currency';

const getCurrencyIntlConfig = (currency: string): Intl.NumberFormatOptions => {
  switch (currency) {
    case 'BHD':
    case 'KWD':
    case 'QAR':
      return {
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
      };
    default:
      return {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      };
  }
};

export const getFormattedAmount = (
  price: string | number,
  currency: CurrencyType,
  hideFractionalPart?: boolean
) => {
  let normalizedPrice = price;

  if (typeof normalizedPrice === 'string') {
    normalizedPrice = parseFloat(normalizedPrice) || 0;
  } else if (Number.isNaN(normalizedPrice)) {
    normalizedPrice = 0;
  }

  const formattedPrice = new Intl.NumberFormat(
    'en-US',
    hideFractionalPart
      ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
      : getCurrencyIntlConfig(currency)
  ).format(normalizedPrice);

  return formattedPrice;
};
